import { DeleteUserBase } from "../DeleteUserBase";

/**
 * Delete a administrator.
 */
export const DeleteAdministrator = () => (<DeleteUserBase defaultRoleGroup={'Esitu staff'} />);
